// @flow
/* eslint consumerweb/require-pagename:0 */
import React, { Component } from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import { StyleSheet, css } from 'lib/paypalphrodite'
import { toggleOpenBankingOverpanel } from 'transfer/actions/overpanels'
import BankDetails from './bankDetails'
import { buildBankDetails } from '../../utils/funding-option-utils'
import { Container, Row, Col, Text, Button, Link } from '@paypalcorp/pp-react'
import content from 'pp-react-l10n'
import {
  trackOpenBankingImpression,
  trackOpenBankingClick,
} from '../../utils/openBankingAnalytics'
import { CONTINGENCY } from '../../../../../lib/constants'
import { extractRTBContingency } from '../../../../../lib/utils/openBankingSharedUtils'
let i18n = content('transfer/inc/openBanking')

type Props = {
  isMobile: boolean,
  selectedFundingOption: any,
  dispatch: Function,
  handleNext: Function,
  isCFPBEnabledCountry: boolean,
  userAccountType: string,
  isCardArtEnabled: boolean,
  country: string,
}

export class OpenBanking extends Component<Props> {
  styles = StyleSheet.create({
    obHeader: { textAlign: 'center', marginBottom: '2.5rem' },
    obInfo: { margin: this.props.isMobile ? '1.625rem 0' : '2rem 0' },
    privacyLink: { fontSize: '0.8125rem', lineHeight: '1.125rem' },
    obAgreeBtn: {
      display: 'block',
      margin: '1rem auto',
      width: this.props.isMobile ? '100%' : '50%',
    },
    payAnotherWay: {
      ':hover': {
        cursor: 'pointer',
      },
    },
  })

  componentDidMount() {
    const { selectedFundingOption } = this.props
    const rtbContingency = extractRTBContingency(selectedFundingOption).action
    if (rtbContingency === CONTINGENCY.INVALID_CREDENTIALS) {
      trackOpenBankingImpression('openBankingReConsent')
    } else {
      trackOpenBankingImpression('openBankingObtainConsent')
    }
  }

  handleClose = () => {
    trackOpenBankingClick('payAnotherWay')
    this.props.dispatch(toggleOpenBankingOverpanel({ show: false }))
  }

  handleContinue = () => {
    trackOpenBankingClick('agreeAndLogin')
    this.props.handleNext()
  }

  getAggregatorName = () => {
    switch (this.props.country) {
      case 'DE':
        return i18n('openBanking.aggregatorName.figo')
      case 'GB':
        return i18n('openBanking.aggregatorName.tink')
      default:
        return i18n('openBanking.aggregatorName.yodlee')
    }
  }

  renderDisclosureStatement = () => {
    const { country } = this.props
    const aggregatorName = this.getAggregatorName()

    const privacyStatementLink = (
      <Link
        href={`/${country}/webapps/mpp/ua/privacy-full`}
        target="_blank"
        className={css(this.styles.privacyLink)}
      >
        {i18n('openBanking.privacyStatement')}
      </Link>
    )

    if (country === 'DE') {
      return (
        <>
          <Text size="sm" className={css(this.styles.obInfo)}>
            {i18n.html('openBanking.informationDE')}
          </Text>
          <Text size="sm" className={css(this.styles.obInfo)}>
            {i18n('openBanking.privacyStatementDE', {
              privacyStatementLink,
            })}
          </Text>
        </>
      )
    }

    if (country === 'GB') {
      return (
        <>
          <Text size="sm" className={css(this.styles.obInfo)}>
            {i18n.html('openBanking.informationGB')}
          </Text>
          <Text size="sm" className={css(this.styles.obInfo)}>
            {i18n('openBanking.privacyStatementGB', {
              privacyStatementLink,
            })}
          </Text>
        </>
      )
    }

    return (
      <Text size="sm" className={css(this.styles.obInfo)}>
        {i18n('openBanking.information', {
          privacyStatementLink,
          aggregatorName,
        })}
      </Text>
    )
  }

  render() {
    const {
      selectedFundingOption,
      isCFPBEnabledCountry,
      userAccountType,
      isCardArtEnabled,
      country,
    } = this.props

    const bankDetails = buildBankDetails(
      selectedFundingOption,
      isCFPBEnabledCountry,
      userAccountType,
      isCardArtEnabled
    )

    let header = i18n('openBanking.header')

    if (country === 'DE') {
      header = i18n('openBanking.headerDE')
    }

    return (
      <Container>
        <Row>
          <Col sm={12}>
            <Text size="xl2" regular className={css(this.styles.obHeader)}>
              {header}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <BankDetails
              bank={bankDetails}
              isMobile={this.props.isMobile}
            ></BankDetails>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>{this.renderDisclosureStatement()}</Col>
        </Row>
        <Row>
          <Col sm={12} style={{ textAlign: 'center' }}>
            <Button
              onClick={this.handleContinue}
              className={css(this.styles.obAgreeBtn)}
              data-nemo="agree-and-login"
            >
              {i18n('openBanking.agreeAndLogin')}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col sm={12} style={{ textAlign: 'center' }}>
            <Link
              onClick={this.handleClose}
              className={css(this.styles.payAnotherWay)}
            >
              {i18n('openBanking.payAnotherWay')}
            </Link>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default connect(({ server, transaction }, props) => ({
  isMobile: server.isMobile,
  selectedFundingOption:
    props.selectedFundingOption || transaction.selectedFundingOption,
  isCFPBEnabledCountry: server.isCFPBEnabledCountry,
  userAccountType: server.userAccountType,
  isCardArtEnabled: server.features && server.features.isCardArtEnabled,
  country: server.country,
}))(OpenBanking)
